

















































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';

import ErrorAnimation from '@/mixins/ErrorAnimation';

type CheckboxVariant = 'default' | 'toggle';

@Component({})
export default class Checkbox extends Mixins(ErrorAnimation) {
	@Prop({required: false, default: 'default'}) readonly variant: CheckboxVariant;
	@Prop({required: false}) readonly label: string | boolean;
	@Prop({default: false}) readonly required: string;
	@Prop({default: false}) readonly isChecked: boolean;
	@Prop({default: false}) readonly disabled: boolean;
	@Prop({default: null}) readonly tabIndex?: number;

	@Prop() readonly styles?: CSSStyleDeclaration;
	@Prop() readonly classes?: Array<string>;

	fieldName: string = `checkbox@${Math.random()}`;

	isValid: boolean = true;
	checked: boolean = this.isChecked;

	error: string | null = null;

	get classList(): Array<string | null> {
		return [
			'checkbox',
			this.variant ? `checkbox--${this.variant}` : null,
			this.disabled ? 'checkbox--disabled' : null,
			(this.isValid !== null && !this.isValid) ? 'checkbox--error' : null,
			...(this.classes || [])
		];
	}

	@Watch('checked')
	onValueChanged(newValue: boolean): void {
		this.isValid = true;

		this.$emit('input', newValue);
	}

	validate(): boolean {
		this.error = null;
		this.isValid = this.required ? this.checked : true;

		if (this.required && !this.isValid) {
			this.error = this.$t('error.form.required') as string;
		}

		return this.isValid;
	}
}
